var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconTrashCupom = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.665,
    height: 17.272,
    viewBox: "0 0 16.665 17.272",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9197",
    "data-name": "Grupo 9197",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_932",
    "data-name": "Grupo 932",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_931",
    "data-name": "Grupo 931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_930",
    "data-name": "Grupo 930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_924",
    "data-name": "Grupo 924",
    transform: "translate(1.751 4.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2453",
    "data-name": "Caminho 2453",
    d: "M982.817,870.133l-.476,10.213a.92.92,0,0,1-.95.814H973.1a.921.921,0,0,1-.95-.814l-.475-10.213a.125.125,0,0,0-.135-.111.122.122,0,0,0-.124.12l.475,10.213a1.168,1.168,0,0,0,1.209,1.037h8.293a1.167,1.167,0,0,0,1.209-1.037l.476-10.213a.122.122,0,0,0-.124-.12A.125.125,0,0,0,982.817,870.133Z",
    transform: "translate(-971.414 -870.022)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_928",
    "data-name": "Grupo 928",
    transform: "translate(0 2.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2457",
    "data-name": "Caminho 2457",
    d: "M969.339,866.6h14.868a.141.141,0,1,0,0-.282H969.339a.141.141,0,1,0,0,.282Z",
    transform: "translate(-969.19 -866.314)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_929",
    "data-name": "Grupo 929",
    transform: "translate(4.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2458",
    "data-name": "Caminho 2458",
    d: "M980.6,865l.3-1.124c.123-.459.506-.844.837-.844h3.1c.333,0,.714.383.837.844l.3,1.124.263-.156-.3-1.123c-.167-.62-.651-1.109-1.1-1.109h-3.1c-.446,0-.933.491-1.1,1.109l-.3,1.123Z",
    transform: "translate(-980.337 -862.607)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTrashCupom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_trash_cupom.a4467359.svg";
export { ForwardRef as ReactComponent };